export function isEditorRequested(search: string): boolean {
  return new URLSearchParams(search).has('editor');
}

export function isBoatWorkshopRequested(search: string): boolean {
  return new URLSearchParams(search).has('boats');
}

export function isBotWorkshopRequested(search: string): boolean {
  return new URLSearchParams(search).has('bots');
}

/** Drop `?editor` / `?boats` / `?bots` so a refresh after leaving stays on the splash. */
export function clearSceneSearch(): void {
  const params = new URLSearchParams(globalThis.location.search);

  if (!params.has('editor') && !params.has('boats') && !params.has('bots')) {
    return;
  }

  globalThis.history.replaceState(null, '', '/');
}
